import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import { MdEmail, MdLocationPin, MdPhone, MdArrowForward } from "react-icons/md";
import { IoEarthOutline, IoLogoWhatsapp } from "react-icons/io5";

import contactBanner from "../assets/banner3.jpg";

const CONTACT_CONFIG = {
  locations: [
    {
      label: "Dar es Salaam",
      tag: "Headquarters",
      value: "Bandari House Kurasini, Bandari Street, Dar es Salaam, Tanzania",
      mapUrl: "https://maps.google.com/?q=Bandari+House+Kurasini",
    },
    {
      label: "Kilimanjaro",
      tag: "Regional Office",
      value: "House No 328, Uraa Road, Michael Uroki Ward, Hai, Tanzania",
      mapUrl: "https://maps.google.com/?q=Hai+Kilimanjaro+Tanzania",
    },
  ],
  digital: [
    { icon: <MdEmail />, label: "Email Us", value: "info@thaihk.tz", link: "mailto:info@thaihk.tz" },
  ],
  phones: [
    {
      label: "+255 717 861 061",
      tel: "tel:+255717861061",
      whatsapp: "https://wa.me/255717861061",
    },
  ],
};

const InfoCard = ({ icon, label, tag, value, onClick }) => (
  <div className="contact-info-card" onClick={onClick}>
    <div className="card-content">
      <div className="icon-wrapper">{icon}</div>
      <div className="text-content">
        <div className="d-flex align-items-center gap-2">
          <span className="label">{label}</span>
          {tag && <span className="badge-tag">{tag}</span>}
        </div>
        <p className="value">{value}</p>
      </div>
      <MdArrowForward className="arrow-icon" />
    </div>
  </div>
);

export default function ContactUsContent() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setIsReady(true);
  }, []);

  if (!isReady) return <div className="py-5 text-center">{getInlineLoader()}</div>;

  return (
    <section className="contact-refactor-section">
      <div className="container">
        <div className="row min-vh-75 align-items-stretch g-4">
          
          {/* Left: Content Area */}
          <div className="col-lg-7 d-flex flex-column justify-content-center pe-lg-5">
            <div className="header-block mb-5">
              <h1 className="display-5 fw-bold mb-3">Let's build global <br/><span className="text-gradient">partnerships.</span></h1>
              <p className="lead text-muted">
                Connecting Tanzanian excellence to the world. Whether it's premium mutton or fresh avocados, we're here to facilitate your supply chain.
              </p>
            </div>

            <div className="info-grid">
              <h5 className="section-subtitle">Our Offices</h5>
              <div className="row g-3 mb-4">
                {CONTACT_CONFIG.locations.map((loc, i) => (
                  <div className="col-md-6" key={i}>
                    <InfoCard 
                      icon={<MdLocationPin size={20} />} 
                      label={loc.label} 
                      tag={loc.tag}
                      value={loc.value} 
                      onClick={() => window.open(loc.mapUrl, "_blank")}
                    />
                  </div>
                ))}
              </div>

              <h5 className="section-subtitle">Digital Channels</h5>
              <div className="row g-3">
                {CONTACT_CONFIG.digital.map((item, i) => (
                  <div className="col-md-6" key={i}>
                    <InfoCard 
                      icon={item.icon} 
                      label={item.label} 
                      value={item.value} 
                      onClick={() => window.open(item.link, "_blank")}
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="phone-strip mt-5 p-4 rounded-4 bg-white shadow-sm border d-flex flex-wrap align-items-center justify-content-between">
              <div>
                <small className="text-muted d-block mb-1">Direct Support Line</small>
                <h4 className="fw-bold mb-0">{CONTACT_CONFIG.phones[0].label}</h4>
              </div>
              <div className="d-flex gap-2 mt-3">
                <a href={CONTACT_CONFIG.phones[0].tel} className="btn btn-dark rounded-pill px-4">Call Now</a>
                <a href={CONTACT_CONFIG.phones[0].whatsapp} target="_blank" className="btn btn-whatsapp rounded-pill px-4 d-flex align-items-center gap-2">
                  <IoLogoWhatsapp /> WhatsApp
                </a>
              </div>
            </div>
          </div>

          {/* Right: Visual Experience */}
          <div className="col-lg-5 position-relative d-none d-lg-block">
            <div className="image-experience-wrapper h-100">
              <img src={contactBanner} alt="Logistics" className="main-img shadow-2xl" />
              <div className="floating-stat card shadow-lg p-4">
                <div className="d-flex align-items-center gap-3">
                  <div className="pulse-circle"></div>
                  <div>
                    <h6 className="mb-0 fw-bold text-dark">Global Network</h6>
                    <small className="text-muted">Active Cold Chain Ready</small>
                  </div>
                </div>
              </div>
              <div className="decorative-blob"></div>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        .contact-refactor-section {
          padding: 80px 0;
          background: #fdfdfd;
          overflow: hidden;
          padding-top: calc(50px + var(--topBarHeight));
        }
        .text-gold { color: #b8863d; font-weight: 700; }
        .ls-2 { letter-spacing: 2px; }
        .text-gradient {
          background: linear-gradient(90deg, #142436, #b8863d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .section-subtitle {
          font-size: 0.9rem;
          font-weight: 700;
          text-transform: uppercase;
          color: #adb5bd;
          margin-bottom: 1.5rem;
          display: block;
        }
        
        /* Modern Card Styling */
        .contact-info-card {
          background: #fff;
          border: 1px solid #f1f1f1;
          border-radius: 16px;
          padding: 20px;
          transition: all 0.3s ease;
          cursor: pointer;
          height: 100%;
          position: relative;
        }
        .contact-info-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.05);
          border-color: #d1a157;
        }
        .icon-wrapper {
          width: 40px; height: 40px;
          background: #fff9f0;
          color: #b8863d;
          border-radius: 10px;
          display: grid; place-items: center;
          margin-bottom: 12px;
          font-size: 1.2rem;
        }
        .label { font-weight: 700; color: #142436; font-size: 0.95rem; }
        .value { color: #6c757d; font-size: 0.85rem; margin-top: 5px; line-height: 1.4; margin-bottom: 0; }
        .badge-tag {
          font-size: 0.65rem;
          background: #eee;
          padding: 2px 8px;
          border-radius: 20px;
          color: #666;
        }
        .arrow-icon {
          position: absolute;
          top: 20px; right: 20px;
          color: #eee;
          transition: color 0.3s;
        }
        .contact-info-card:hover .arrow-icon { color: #b8863d; }

        /* Buttons */
        .btn-whatsapp { background: #25D366; color: white; }
        .btn-whatsapp:hover { background: #1eb956; color: white; }

        /* Visual Column */
        .image-experience-wrapper {
          position: relative;
          z-index: 1;
        }
        .main-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 30px;
          z-index: 2;
          position: relative;
        }
        .floating-stat {
          position: absolute;
          bottom: 40px;
          left: -40px;
          z-index: 3;
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          min-width: 240px;
        }
        .pulse-circle {
          width: 12px; height: 12px;
          background: #25D366;
          border-radius: 50%;
          box-shadow: 0 0 0 rgba(37, 211, 102, 0.4);
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
          70% { box-shadow: 0 0 0 10px rgba(37, 211, 102, 0); }
          100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
        }
        .decorative-blob {
          position: absolute;
          top: -20px; right: -20px;
          width: 200px; height: 200px;
          background: radial-gradient(circle, #f0e4d0 0%, transparent 70%);
          z-index: 0;
        }
      `}</style>
    </section>
  );
}